import { Navigate } from "react-router-dom";
import { useContext } from "react";

import { AuthContext } from "../contexts/AuthContext";

const PublicRoute = ({ element }: any) => {
  const { isAuthenticated, user } = useContext(AuthContext);

  if (isAuthenticated) {
    // Check if the user is trying to access the login, forgot password, or reset password page
    const allowedPages = [
      "Login",
      "ForgotPassword",
      "ResetPassword",
      "VerifyOtp",
    ];

    if (
      element &&
      element.type &&
      allowedPages.includes(element.type.displayName)
    ) {
      // Redirect the user to a different page, e.g., the home page
      return (
        <Navigate
          to={
            user &&
            (user.userType === "Super Admin" ||
              user.userType === "Back end Entry User")
              ? "/admin/dashboard"
              : "/"
          }
          replace
        />
      );
    }
  }

  return element;
};

export default PublicRoute;
